import React, { ReactNode, useEffect, useLayoutEffect, useState } from "react";
import { ScrollToTop } from "../components/ScrollToTop";
import { Header } from "./Header";
import { useLocation } from "react-router-dom";
import { Footer } from "./Footer";
import { Video } from "./Video";
import OpenAds from "./OpenAds";
import Ads from "./Ads";
import { fetchHomeAds } from "../api/HomeApi";
import { IAdsData } from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/custom/useToast";

interface LayoutProps {
  children: ReactNode;
  bodyClass?: string;
  breadcrumbTitle?: string;
  breadcrumbSubtitle?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, bodyClass = "" }) => {
  const { pathname } = useLocation();

  const { setLoading } = useLoader();

  useLayoutEffect(() => {
    if (bodyClass) {
      document.body.classList.add(bodyClass);
    }

    return () => {
      if (bodyClass) {
        document.body.classList.remove(bodyClass);
      }
    };
  }, [bodyClass, pathname]);

  const [ads, setAds] = useState<IAdsData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchHomeAds()])
      .then(([homeAdsData]) => {
        setAds(homeAdsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  const filteredAds = ads?.filter((item) => item.display === 1);

  return (
    <>
      <ScrollToTop />

      <OpenAds />

      <Header />

      {filteredAds.length > 0 && <Ads ads={filteredAds} />}

      {/* 
      {breadcrumbTitle && (
        <Breadcrumb title={breadcrumbTitle} subtitle={breadcrumbSubtitle} />
      )} 
      */}

      {children}

      <Video />
      <Footer />

      {/* 
      {footer === 1 && <FooterOne />}
      {footer === 2 && <FooterTwo />}
      {footer === 3 && <FooterThree />}
      {footer === 4 && <FooterFour />}
      {footer === 5 && <FooterFive />}
      {footer === 6 && <FooterSix />}
      {footer === 7 && <FooterSeven />}
      {footer === 8 && <FooterEight />} 
      */}
    </>
  );
};
